import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import Logo from '../../assets/images/hea-logo.png';
import HamburgerIcon from '../../assets/images/hea-hamburger.png';
import SlideOut from './slide-out';
import CSSTransitionGroup from 'react-addons-css-transition-group';

import './nav.scss';
import AuthService from "../../services/authService";

class Nav extends Component {
    constructor(props) {
        super(props);
        // console.log('bring on the nav props: ', props)
        this.state = {
            // showMenu: false
        }
    }

    // handleClick = () => {
    //     this.setState({
    //         showMenu: !this.state.showMenu
    //     })
    // }

    // handleClose = () => {
    //     if(this.state.showMenu){
    //         this.setState({
    //             showMenu: false
    //         })
    //     }
       
    // }


    render() {
        if(this.props.fromAssessment){
            return (
                <div id="nav">
                    <div className="logo">
                        <Link to="/welcome/">
                            <img src={Logo}/>
                        </Link>
                    </div>
                    <div className="social-container">
                        <ul>
                            <li className="social-icon">
                                <Link to="https://www.instagram.com/happilyeveraftercourse/" target="_blank">
                                    <i className="fa fa-instagram"></i>
                                </Link>
                            </li>
                            <li className="social-icon">
                                <Link to="https://twitter.com/marriage365" target="_blank">
                                    <i className="fa fa-twitter"></i>
                                </Link>
                            </li>
                            <li className="social-icon">
                                <Link to="https://www.facebook.com/marriage365/" target="_blank">
                                    <i className="fa fa-facebook-f"></i>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            )
        }
        if (AuthService.assessmentCompleted()) {
            return (
                <div id="nav">
                    <CSSTransitionGroup
                        transitionName="slide"
                        transitionEnterTimeout={500}
                        transitionLeaveTimeout={500}
                    >
                        {this.props.showMenu &&
                        <SlideOut
                            handleClose={this.props.handleClose}
                            checkQuestionsCompleted={this.props.checkQuestionsCompleted}
                            completed={this.props.completed}/>}
                    </CSSTransitionGroup>

                    <div className="hamburger-menu" onClick={this.props.handleClick}>
                        <img src={HamburgerIcon}/>
                    </div>

                    <div className="logo">
                        <Link to="/progress/">
                            <img src={Logo}/>
                        </Link>
                    </div>
                    <div className="social-container">
                        <ul>
                            <li className="social-icon">
                                <a href="https://www.instagram.com/premaritalcourse" target="_blank">
                                    <i className="fa fa-instagram"></i>
                                </a>
                            </li>
                            <li className="social-icon">
                                <a href="https://twitter.com/marriage365" target="_blank">
                                    <i className="fa fa-twitter"></i>
                                </a>
                            </li>
                            <li className="social-icon">
                                <a href="https://www.facebook.com/marriage365/" target="_blank">
                                    <i className="fa fa-facebook-f"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            );
        } else {
            return (
                <div id="nav">
                    <div className="logo">
                        <Link to="/welcome/">
                            <img src={Logo}/>
                        </Link>
                    </div>
                    <div className="social-container">
                        <ul>
                            <li className="social-icon">
                                <Link to="https://www.instagram.com/happilyeveraftercourse/" target="_blank">
                                    <i className="fa fa-instagram"></i>
                                </Link>
                            </li>
                            <li className="social-icon">
                                <Link to="https://twitter.com/marriage365" target="_blank">
                                    <i className="fa fa-twitter"></i>
                                </Link>
                            </li>
                            <li className="social-icon">
                                <Link to="https://www.facebook.com/marriage365/" target="_blank">
                                    <i className="fa fa-facebook-f"></i>
                                </Link>
                            </li>
                        </ul>
                    </div>
                </div>
            );
        }


    }

}

export default Nav;